import { Route, Switch } from 'react-router-dom'
import { Layout } from 'antd'

import SideNavUi from '../components/navigation/SideNavUi'
import CreatePackageLayout from './create/CreatePackageLayout'
import UploadPackage from './upload/UploadPackage'

export const packageUploadStageList = [
  'info',
  'sticker-upload',
  'select-tag',
  'confirm',
] as const
export const noPackageId = 'no-package'
export type packageUploadStage = typeof packageUploadStageList[number]

export default function Upload() {
  return (
    <>
      {/* 밖의 history 변화를 감지하기 위한 컴포넌트 */}
      <Layout style={{ height: 'inherit', background: 'white' }}>
        <SideNavUi
          linkInfoList={[
            {
              pathname: `/upload/create-package`,
              icon: 'edit',
              id: 'Upload.packages.nav.packagesInProgress',
            },
            {
              pathname: `/mypage/mypackage?filter=creating`,
              icon: 'arrow-left',
              id: 'Upload.packages.goto.mypage',
            },
            {
              pathname: `/mypage/packages-of-reviewed`,
              icon: 'arrow-left',
              id: 'Upload.packages.goto.reviewedpage',
            },
          ]}
        />

        <Layout.Content style={{ margin: '20px' }}>
          <Switch>
            <Route
              path="/upload/create-package"
              component={CreatePackageLayout}
            />
            <Route
              path="/upload/package/:packageId"
              component={UploadPackage}
            />
          </Switch>
        </Layout.Content>
      </Layout>
    </>
  )
}
